webpackJsonp([6972000345134],{

/***/ 97:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/final.210e021e.png";

/***/ }),

/***/ 736:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(3);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _Quickstart = __webpack_require__(9);
	
	var _Quickstart2 = _interopRequireDefault(_Quickstart);
	
	var _Markdown = __webpack_require__(5);
	
	var _Markdown2 = _interopRequireDefault(_Markdown);
	
	var _CodeTabs = __webpack_require__(7);
	
	var _CodeTabs2 = _interopRequireDefault(_CodeTabs);
	
	var _CodeTab = __webpack_require__(6);
	
	var _CodeTab2 = _interopRequireDefault(_CodeTab);
	
	var _QuickstartBranch = __webpack_require__(8);
	
	var _QuickstartBranch2 = _interopRequireDefault(_QuickstartBranch);
	
	var _final = __webpack_require__(97);
	
	var _final2 = _interopRequireDefault(_final);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  return _react2.default.createElement(
	    _Quickstart2.default,
	    null,
	    _react2.default.createElement(
	      'h1',
	      null,
	      'Step 3: Add the Header'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'In this step we\'re going to lay out the application and add a Header at the top of the page.'
	    ),
	    _react2.default.createElement(_QuickstartBranch2.default, { branch: 'layout.3' }),
	    _react2.default.createElement(
	      'h3',
	      null,
	      'Generate the Header'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'The Lore CLI includes a number of commands to create various types of project files. One of those commands is',
	      _react2.default.createElement(
	        'code',
	        null,
	        'generate'
	      ),
	      ', and we\'ll be using it to generate the ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'Header'
	      ),
	      ' component.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Run this command from the CLI:'
	    ),
	    _react2.default.createElement(_Markdown2.default, { type: 'sh', text: '\n      lore generate component Header\n      ' }),
	    _react2.default.createElement(
	      'blockquote',
	      null,
	      _react2.default.createElement(
	        'p',
	        null,
	        'You can learn more about the ',
	        _react2.default.createElement(
	          'code',
	          null,
	          'generate component'
	        ),
	        ' command ',
	        _react2.default.createElement(
	          _gatsbyLink2.default,
	          { to: '/cli/lore-generate-component/' },
	          'here'
	        ),
	        '.'
	      )
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'This command will generate a component called ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'Header'
	      ),
	      ' and place it at ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'src/components/Header.js'
	      ),
	      '. The syntax of this file will match whichever version of JavaScript you specified when you created the project (ES5, ES6 or ESNext) and will look like this:'
	    ),
	    _react2.default.createElement(
	      _CodeTabs2.default,
	      null,
	      _react2.default.createElement(_CodeTab2.default, { syntax: 'ES5', text: '\n        import React from \'react\';\n        import createReactClass from \'create-react-class\';\n        import PropTypes from \'prop-types\';\n\n        export default createReactClass({\n          displayName: \'Header\',\n\n          propTypes: {},\n\n          render() {\n            return (\n              <div></div>\n            );\n          }\n        });\n        ' }),
	      _react2.default.createElement(_CodeTab2.default, { syntax: 'ES6', text: '\n        import React from \'react\';\n        import PropTypes from \'prop-types\';\n\n        class Header extends React.Component {\n\n          constructor(props) {\n            super(props);\n\n            // Set your initial state here\n            // this.setState = {};\n\n            // Bind your custom methods so you can access the expected \'this\'\n            // this.myCustomMethod = this.myCustomMethod.bind(this);\n          }\n\n          render() {\n            return (\n              <div></div>\n            );\n          }\n        }\n\n        Header.propTypes = {};\n\n        export default Header;\n        ' }),
	      _react2.default.createElement(_CodeTab2.default, { syntax: 'ESNext', text: '\n        import React from \'react\';\n        import PropTypes from \'prop-types\';\n\n        class Header extends React.Component {\n\n          static propTypes = {}\n\n          render() {\n            return (\n              <div></div>\n            );\n          }\n\n        }\n\n        export default Header;\n        ' })
	    ),
	    _react2.default.createElement(
	      'h3',
	      null,
	      'Modify the Header'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Next, modify the ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'render()'
	      ),
	      ' method to look like this:'
	    ),
	    _react2.default.createElement(_Markdown2.default, { type: 'jsx', text: '\n      // src/components/Header.js\n      ...\n        render() {\n          return (\n            <nav className="navbar navbar-default navbar-static-top header">\n              <div className="container">\n                <div className="navbar-header">\n                  <div className="navbar-brand">\n                    Lore Quickstart\n                  </div>\n                </div>\n              </div>\n            </nav>\n          );\n        }\n      ...\n      ' }),
	    _react2.default.createElement(
	      'h3',
	      null,
	      'Add Header to Layout'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Finally, let\'s render the ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'Header'
	      ),
	      ' in the browser. Open the ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'Layout'
	      ),
	      ' component and import the ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'Header'
	      ),
	      '. Then update the ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'render()'
	      ),
	      ' method to look like this:'
	    ),
	    _react2.default.createElement(
	      _CodeTabs2.default,
	      null,
	      _react2.default.createElement(_CodeTab2.default, { syntax: 'ES5', text: '\n        // src/components/Layout.js\n        import Header from \'./Header\';\n        ...\n          render() {\n            return (\n              <div>\n                <Header />\n                <div className="container">\n                  <div className="row">\n                    <div className="col-md-offset-3 col-md-6">\n                      {/* Feed will go here */}\n                    </div>\n                  </div>\n                </div>\n              </div>\n            );\n          }\n        ...\n        ' }),
	      _react2.default.createElement(_CodeTab2.default, { syntax: 'ES6', text: '\n        // src/components/Layout.js\n        import Header from \'./Header\';\n        ...\n          render() {\n            return (\n              <div>\n                <Header />\n                <div className="container">\n                  <div className="row">\n                    <div className="col-md-offset-3 col-md-6">\n                      {/* Feed will go here */}\n                    </div>\n                  </div>\n                </div>\n              </div>\n            );\n          }\n        ...\n        ' }),
	      _react2.default.createElement(_CodeTab2.default, { syntax: 'ESNext', text: '\n        // src/components/Layout.js\n        import Header from \'./Header\';\n        ...\n          render() {\n            return (\n              <div>\n                <Header />\n                <div className="container">\n                  <div className="row">\n                    <div className="col-md-offset-3 col-md-6">\n                      {/* Feed will go here */}\n                    </div>\n                  </div>\n                </div>\n              </div>\n            );\n          }\n        ...\n        ' })
	    ),
	    _react2.default.createElement(
	      'h3',
	      null,
	      'Visual Check-in'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'If everything went well, your application should now look like this.'
	    ),
	    _react2.default.createElement('img', { className: 'drop-shadow', src: _final2.default }),
	    _react2.default.createElement(
	      'h2',
	      null,
	      'Code Changes'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Below is a list of files modified during this step.'
	    ),
	    _react2.default.createElement(
	      'h3',
	      null,
	      'src/components/Header.js'
	    ),
	    _react2.default.createElement(
	      _CodeTabs2.default,
	      null,
	      _react2.default.createElement(_CodeTab2.default, { syntax: 'ES5', text: '\n        import React from \'react\';\n        import createReactClass from \'create-react-class\';\n        import PropTypes from \'prop-types\';\n\n        export default createReactClass({\n          displayName: \'Header\',\n\n          render() {\n            return (\n              <nav className="navbar navbar-default navbar-static-top header">\n                <div className="container">\n                  <div className="navbar-header">\n                    <div className="navbar-brand">\n                      Lore Tutorial\n                    </div>\n                  </div>\n                </div>\n              </nav>\n            );\n          }\n\n        });\n        ' }),
	      _react2.default.createElement(_CodeTab2.default, { syntax: 'ES6', text: '\n        import React from \'react\';\n        import PropTypes from \'prop-types\';\n\n        class Header extends React.Component {\n\n          render() {\n            return (\n              <nav className="navbar navbar-default navbar-static-top header">\n                <div className="container">\n                  <div className="navbar-header">\n                    <div className="navbar-brand">\n                      Lore Quickstart\n                    </div>\n                  </div>\n                </div>\n              </nav>\n            );\n          }\n\n        }\n\n        export default Header;\n        ' }),
	      _react2.default.createElement(_CodeTab2.default, { syntax: 'ESNext', text: '\n        import React from \'react\';\n        import PropTypes from \'prop-types\';\n\n        class Header extends React.Component {\n\n          render() {\n            return (\n              <nav className="navbar navbar-default navbar-static-top header">\n                <div className="container">\n                  <div className="navbar-header">\n                    <div className="navbar-brand">\n                      Lore Quickstart\n                    </div>\n                  </div>\n                </div>\n              </nav>\n            );\n          }\n\n        }\n\n        export default Header;\n        ' })
	    ),
	    _react2.default.createElement(
	      'h3',
	      null,
	      'src/components/Layout.js'
	    ),
	    _react2.default.createElement(
	      _CodeTabs2.default,
	      null,
	      _react2.default.createElement(_CodeTab2.default, { syntax: 'ES5', text: '\n        /**\n         * This component is intended to reflect the high level structure of your application,\n         * and render any components that are common across all views, such as the header or\n         * top-level navigation. All other components should be rendered by route handlers.\n         */\n\n        import React from \'react\';\n        import createReactClass from \'create-react-class\';\n        import PropTypes from \'prop-types\';\n        import Header from \'./Header\';\n\n        export default createReactClass({\n          displayName: \'Layout\',\n\n          render() {\n            return (\n              <div>\n                <Header />\n                <div className="container">\n                  <div className="row">\n                    <div className="col-md-offset-3 col-md-6">\n                      {/* Feed will go here */}\n                    </div>\n                  </div>\n                </div>\n              </div>\n            );\n          }\n\n        });\n        ' }),
	      _react2.default.createElement(_CodeTab2.default, { syntax: 'ES6', text: '\n        /**\n         * This component is intended to reflect the high level structure of your application,\n         * and render any components that are common across all views, such as the header or\n         * top-level navigation. All other components should be rendered by route handlers.\n         */\n\n        import React from \'react\';\n        import PropTypes from \'prop-types\';\n        import Header from \'./Header\';\n\n        class Layout extends React.Component {\n\n          render() {\n            return (\n              <div>\n                <Header />\n                <div className="container">\n                  <div className="row">\n                    <div className="col-md-offset-3 col-md-6">\n                      {/* Feed will go here */}\n                    </div>\n                  </div>\n                </div>\n              </div>\n            );\n          }\n\n        }\n\n        export default Layout;\n        ' }),
	      _react2.default.createElement(_CodeTab2.default, { syntax: 'ESNext', text: '\n        /**\n         * This component is intended to reflect the high level structure of your application,\n         * and render any components that are common across all views, such as the header or\n         * top-level navigation. All other components should be rendered by route handlers.\n         */\n\n        import React from \'react\';\n        import PropTypes from \'prop-types\';\n        import Header from \'./Header\';\n\n        class Layout extends React.Component {\n\n          render() {\n            return (\n              <div>\n                <Header />\n                <div className="container">\n                  <div className="row">\n                    <div className="col-md-offset-3 col-md-6">\n                      {/* Feed will go here */}\n                    </div>\n                  </div>\n                </div>\n              </div>\n            );\n          }\n\n        }\n\n        export default Layout;\n        ' })
	    ),
	    _react2.default.createElement(
	      'h2',
	      null,
	      'Next Steps'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Next we\'re going to ',
	      _react2.default.createElement(
	        _gatsbyLink2.default,
	        { to: '../../routing/overview/' },
	        'setup routing'
	      ),
	      '.'
	    )
	  );
	};
	
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-quickstart-layout-step-3-js-74dcb3b4de3862551b22.js